module.exports = __webpack_public_path__ + "img/report-banner.baabae59.png";